import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import { errorToast } from "../../../utils/toasts";

export function useConfirmUpload(uploadId: number) {
  const queryClient = useQueryClient();
  const { t } = useTranslation(["uploads"]);

  const confirmProcessMutation = useMutation({
    mutationFn: async () => await apiClient.processUpload({ async_run: true }, { params: { id: uploadId } }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [{ entity: "uploads" }] });
    },
    onError: (error) => {
      errorToast({
        title: t(($) => $.uploads.toasts["Failed to process upload"]),
        message: t(($) => $.uploads.toasts["Please try again or contact support."]),
        error,
      });
    },
  });

  const ignoreWarningsMutation = useMutation({
    mutationFn: async () =>
      await apiClient.processUpload({ ignoreWarnings: true, async_run: true }, { params: { id: uploadId } }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [{ entity: "uploads" }] });
    },
    onError: (error) => {
      errorToast({
        title: t(($) => $.uploads.toasts["Failed to reprocess upload"]),
        message: t(($) => $.uploads.toasts["Please try again or contact support."]),
        error,
      });
    },
  });

  return {
    confirmProcess: confirmProcessMutation.mutate,
    ignoreWarnings: ignoreWarningsMutation.mutate,
    isPending: confirmProcessMutation.isPending || ignoreWarningsMutation.isPending,
  };
}
